import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
Swiper.use([ Navigation ]);

export default class Projects {
    constructor() {
        if($('.js-projects').length) {
            const $slider = $('.js-projects');

            const projects = new Swiper($slider[0], {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 'auto',
                spaceBetween: 20,
                watchOverflow: true
            });

            projects.init();
        };
    };
};
